export const MemesPoint = {
  pageName: 'Memes',
  pageId: '25104',
  pagePath: '/marketing/Memes',
  common: {
    source: 2,
    typeId: 'opinions_market_pc_v2',
  },
  button: {
    meme_drawer_open: {
      buttonId: '2510401',
    },
    meme_detail_enter: {
      buttonId: '2510402',
    },
    export_data_click: {
      buttonId: '2510403',
    },
  },
  card: {},
};
